import {ApiClientService, EntityApiService} from '@dofleini/security';
import {authentication} from '@/settings';

const adaptResultFromAPI = r => ({ ...r, headers: { 'x-total-count': r.total }, });

class AhabService extends EntityApiService {

  searchMunicipalities = async (params) => {
    const response = await ApiClientService.get(this.getPath('/address/municipalities'), params);
    return adaptResultFromAPI(response?.data);
  }

  searchStreet = async (params) => {
    const response = await ApiClientService.get(this.getPath(`/address/streets/${params.municipality}`), params);
    return adaptResultFromAPI(response?.data);
  }

  searchNeighborHood = async (params) => {
    const response = await ApiClientService.get(this.getPath(`/address/popular-councils/${params.municipality}`), params);
    return adaptResultFromAPI(response?.data);
  }

  searchOrganizations = async (params) => {
    const response = await ApiClientService.get(this.getPath('/organizations'), params);
    return adaptResultFromAPI(response?.data);
  }

  associateCC = async (params) => {
    return ApiClientService.post(this.getPath('/associate-cc'), params);
  }

  validateCC = async (params) => {
    return ApiClientService.post(this.getPath('/validate-ccs'), {cc: params.cc});
  }

  debtsCC = async (params) => {
    return ApiClientService.post(this.getPath('/debts-ccs'), params);
  }

  invoiceCC = async (params) => {
    return ApiClientService.post(this.getPath('/invoice-cc'), params);
  }

  debtsInvoices = async (params) => {
    return ApiClientService.post(this.getPath('/debts-invoice'), params);
  }

  advanceBalance = async (params) => {
    return ApiClientService.post(this.getPath('/advance-balance'), params);
  }

  totalDebt = async (params) => {
    return ApiClientService.post(this.getPath('/total-debt'), {cc: params});
  }

  validateReq = async (params) => {
    return ApiClientService.post(this.getPath('/validate-req'), params);
  }
}

export default new AhabService(`${authentication.path}/api/ahab-requests`);
